export enum AccountToKeep {
  MAIN = 'MAIN',
  OTHER = 'OTHER',
}
